// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-relevance-chooser{margin-top:0.5rem;font-family:Fira Sans Condensed, Rubik, Helvetica, Arial Narrow, Arial, sans-serif;font-size:0.875rem}.search-relevance-chooser__option{margin-left:0.5rem;cursor:pointer}.search-relevance-chooser__option--selected{font-weight:700;--tw-text-opacity:1;color:rgb(0 103 171 / var(--tw-text-opacity))}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
